<div class="container-fluid">
  <ngx-alerts></ngx-alerts>
  <app-pagetitle
    [title]="'Showing Driving Alerts of: '+name+(search.tripId? (' - '+ (drivingAlerts && drivingAlerts.length?getVehicleName(drivingAlerts[0]):'')):'')"></app-pagetitle>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="table-responsive mt-3">
            <table class="table table-centered datatable dt-responsive nowrap"
                   style="border-collapse: collapse; border-spacing: 0; width: 100%;">
              <thead class="thead-light">
              <tr>
                <th>S.No.</th>
                <th>Alert</th>
                <th>Alert Value</th>
                <th style="max-width: 200px">Impact</th>
                <th>G-Force</th>
                <th>CreatedOn</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let item of drivingAlerts; let i= index">
                <td>{{i + 1}}</td>
                <td>{{item.alertData['alert_Type']}}</td>
                <td>{{item.alertData['alert_value']}}</td>
                <td style="max-width: 200px" class="text-wrap">{{item.alertData['impact']}}</td>
                <td>{{item.alertData['g_force']}}</td>
                <td>{{item.createdOn}}</td>
              </tr>
              </tbody>
            </table>
            <mat-paginator (page)="pageEvent = getServerData($event)" [length]="totalRecords"
                           [pageSize]="search.size"
                           [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
